export default __webpack_public_path__ + "713958e2d30a7ef7bdc3a29b4d0a59e4.gif";